import { createTileLayerComponent } from "@react-leaflet/core";
import L from "leaflet";
import "@maplibre/maplibre-gl-leaflet";
import "maplibre-gl/dist/maplibre-gl.css";

// Wraps maplibre-gl vector tiles as a react-leaflet layer.
// Usage: <MapLibreTileLayer url="https://tiles.openfreemap.org/styles/liberty" attribution="..." />
export const MapLibreTileLayer = createTileLayerComponent(
  function createTileLayer({ url, attribution, ...options }, context) {
    const layer = L.maplibreGL({ style: url, attribution, ...options });
    return { instance: layer, context };
  },
  function updateTileLayer(layer, props, prevProps) {
    if (props.url !== prevProps.url) {
      const mlMap = layer.getMaplibreMap && layer.getMaplibreMap();
      if (mlMap) mlMap.setStyle(props.url);
    }
  }
);
